module.exports = __webpack_public_path__ + "topic_icon.c5b1e8f9.png";